import { StackScreenProps } from "@react-navigation/stack";
import { FlatActionList, Page } from "@towersystems/roam-common-native";
import { useTranslation } from "react-i18next";
import { LlmStrategyFormValues } from "../../components/LlmStrategyForm";
import { useFormContext } from "react-hook-form";
import { View } from "react-native";

const LlmTypes = [
  {
    value: "openai",
    label: "OpenAI",
    description:
      "Bring your own key, and use OpenAI's language models. Used for text based features.",
  },
  {
    value: "anthropic",
    label: "Anthropic",
    description:
      "Bring your own key, and use Anthropic's language models. Used for text based features.",
  },
  {
    value: "gemini",
    label: "Gemini",
    description:
      "Bring your own key, and use Google's Gemini language models. Used for text based features.",
  },
  {
    value: "openai_dalle",
    label: "OpenAI DALL·E",
    description:
      "Bring your own key, and use OpenAI's DALL·E image models. Used for image generation features.",
  },
];

export interface SelectLlmTypeScreenProps
  extends StackScreenProps<any, "SelectLlmTypeScreen"> {}

export const SelectLlmTypeScreen = ({
  navigation,
}: SelectLlmTypeScreenProps) => {
  const { t } = useTranslation("settings");
  const { getValues, setValue } = useFormContext<LlmStrategyFormValues>();
  const watchedKeyType = getValues("code");
  const handleOnSelect = (code: string) => {
    setValue("code", code, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    navigation.goBack();
  };
  return (
    <Page
      title={t("title.select_llm_type")}
      secondaryTitle={t("title.select_llm_type_secondary")}
    >
      <View>
        <FlatActionList
          items={LlmTypes.map((llmType) => ({
            key: llmType.value,
            title: llmType.label,
            subTitle: llmType.description,
            selected: llmType.value === watchedKeyType,
            onPress: () => {
              handleOnSelect(llmType.value);
            },
          }))}
        />
      </View>
    </Page>
  );
};
